<div class="wrapper" [class.no-map]="!hasAlignmentGeometry">
  <div *ngIf="hasAlignmentGeometry" class="map-panel">
    <div *ngIf="stationRangeMapData" class="station-range-map-section">
      <app-survey-data-map [geometry]="stationRangeMapData.geometry" />
      <div *ngIf="stationRangeMapData.fromLabel" class="station-map-label station-map-label-from">
        {{ stationRangeMapData.fromLabel }}
      </div>
      <div *ngIf="stationRangeMapData.toLabel" class="station-map-label station-map-label-to">
        {{ stationRangeMapData.toLabel }}
      </div>
      <div *ngIf="form.controls?.alignment?.value" class="alignment-map-label">
        <strong>{{ form.controls.alignment.value }}</strong>
        <span *ngIf="stationRangeMapData.fromLabel">{{ stationRangeMapData.fromLabel }}</span>
      </div>
    </div>
  </div>

  <div class="form-panel">
    <div class="heading text-type-2 flex flex-row justify-between items-center">
      <div class="counter text-type-2">
        Add station range
      </div>
      <mat-icon (click)="close()">close</mat-icon>
    </div>

    <div class="form-content">
      <div class="alignment-section" *ngIf="false && alignmentOptions.length > 1">
      <app-dropdown
        *ngIf="alignmentOptions.length; else alignmentTextInput"
        [enableSearch]="true"
        [options]="alignmentOptions"
        [parentFormGroup]="form"
        class="w-full"
        controlName="alignment"
        label="alignment"
      />
      <ng-template #alignmentTextInput>
        <app-text-input
          [parentFormGroup]="form"
          class="w-full"
          controlName="alignment"
          label="alignment"
        />
      </ng-template>
    </div>

      <div class="from-section section-block">
    <div class="section-heading text-type-8">
      FROM
    </div>
    <div class="from-details w-full">
      <div class="from-details flex flex-row justify-start items-center field-row w-full">
        <mat-form-field
          [formGroup]="form"
          appearance="fill"
          class="form-field station-input-field w-full"
          floatLabel="always"
          hideRequiredMarker
        >
          <mat-label class="label">station:</mat-label>
          <input
            formControlName="stationRangeFromStation"
            matInput
            [matAutocomplete]="fromStationAuto"
          />
          <mat-icon class="suffix-icon" matSuffix svgIcon="chevron-light" />
          <mat-autocomplete #fromStationAuto="matAutocomplete">
            <mat-option *ngFor="let option of filteredFromStationOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="from-details flex flex-row justify-start items-center offset-row w-full">
        <app-dropdown
          [options]="offsetTypeOptions"
          [parentFormGroup]="form"
          [sentenceCase]="true"
          class="w-1/2"
          controlName="stationRangeFromOffsetType"
          label="Offset type"
        />
        <app-number-input
          [parentFormGroup]="form"
          [isDecimalAllowed]="true"
          class="w-1/2"
          controlName="stationRangeFromOffsetDistance"
          label="Offset distance"
        />
      </div>
    </div>
  </div>

      <div class="to-section section-block">
    <div class="section-heading text-type-8">
      TO
    </div>
    <div class="to-details w-full">
      <div class="to-details flex flex-row justify-start items-center field-row w-full">
        <mat-form-field
          [formGroup]="form"
          appearance="fill"
          class="form-field station-input-field w-full"
          floatLabel="always"
          hideRequiredMarker
        >
          <mat-label class="label">station:</mat-label>
          <input
            formControlName="stationRangeToStation"
            matInput
            [matAutocomplete]="toStationAuto"
          />
          <mat-icon class="suffix-icon" matSuffix svgIcon="chevron-light" />
          <mat-autocomplete #toStationAuto="matAutocomplete">
            <mat-option *ngFor="let option of filteredToStationOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="to-details flex flex-row justify-start items-center offset-row w-full">
        <app-dropdown
          [options]="offsetTypeOptions"
          [parentFormGroup]="form"
          [sentenceCase]="true"
          class="w-1/2"
          controlName="stationRangeToOffsetType"
          label="Offset type"
        />
        <app-number-input
          [parentFormGroup]="form"
          [isDecimalAllowed]="true"
          class="w-1/2"
          controlName="stationRangeToOffsetDistance"
          label="Offset distance"
        />
      </div>
    </div>
  </div>

    </div>

  <div class="action-section w-full flex flex-row justify-start items-center">
    <app-primary-button
      (handleClick)="save()"
      [isDisabled]="!checkStationFormData()"
      class="w-full">
      Add
    </app-primary-button>
  </div>
  </div>
</div>
